(function () {
  const calculator = document.getElementById("rr-rainwater-calculator");

  if (!calculator || calculator.dataset.initialised === "true") {
    return;
  }

  calculator.dataset.initialised = "true";

  const form = document.getElementById("rr-calculator-form");
  const postcodeInput = document.getElementById("rr-postcode");
  const postcodeButton = document.getElementById("rr-postcode-button");
  const postcodeMessage = document.getElementById("rr-postcode-message");
  const formMessage = document.getElementById("rr-form-message");
  const locationResult = document.getElementById("rr-location-result");
  const results = document.getElementById("rr-results");

  const roofLengthInput = document.getElementById("rr-roof-length");
  const roofDepthInput = document.getElementById("rr-roof-depth");
  const roofPitchInput = document.getElementById("rr-roof-pitch");
  const roofTypeInput = document.getElementById("rr-roof-type");
  const hippedSideInput = document.getElementById("rr-hipped-side");
  const hippedSideField = document.getElementById("rr-hipped-side-field");
  const roofLengthLabel = document.getElementById("rr-roof-length-label");
  const roofDepthLabel = document.getElementById("rr-roof-depth-label");
  const roofTypeHelp = document.getElementById("rr-roof-type-help");
  const roofTypeButtons = document.querySelectorAll(".rr-roof-type-option");

  const gutterFamilyInput = document.getElementById("rr-gutter-family");
  const outletCountInput = document.getElementById("rr-outlet-count");
  const outletCountField = document.getElementById("rr-outlet-count-field");
  const outletShapeInput = document.getElementById("rr-outlet-shape");

  const outletArrangementInput = document.getElementById(
    "rr-outlet-arrangement"
  );

  const outletPositionsInput = document.getElementById(
    "rr-outlet-positions"
  );

  const outletPositionsField = document.getElementById(
    "rr-outlet-positions-field"
  );

  const leafGuardInput = document.getElementById("rr-leaf-guard");

  const outletObstructionInput = document.getElementById(
    "rr-outlet-obstruction"
  );

  const gutterCornerInput = document.getElementById("rr-gutter-corner");
  const roofSurfaceInput = document.getElementById("rr-roof-surface");
  const eavesDetailInput = document.getElementById("rr-eaves-detail");

  const flowConcentrationInput = document.getElementById(
    "rr-flow-concentration"
  );

  const verticalDropInput = document.getElementById("rr-vertical-drop");
  const gutterOverlapInput = document.getElementById("rr-gutter-overlap");

  const gutterTrigger = document.getElementById("rr-gutter-trigger");
  const gutterOptions = document.getElementById("rr-gutter-options");

  const selectedGutterImage = document.getElementById(
    "rr-selected-gutter-image"
  );

  const selectedGutterName = document.getElementById(
    "rr-selected-gutter-name"
  );

  const gutterOptionButtons = document.querySelectorAll(
    ".rr-gutter-option"
  );

  function updateRoofTypeFields() {
    const roofType = roofTypeInput.value;
    const isWholeRoof =
      roofType === "gable" || roofType === "hipped";

    roofTypeButtons.forEach(function (button) {
      const selected = button.dataset.roofType === roofType;

      button.classList.toggle("selected", selected);
      button.setAttribute("aria-pressed", String(selected));
    });

    hippedSideField.hidden = roofType !== "hipped";

    roofLengthLabel.textContent = isWholeRoof
      ? "Overall roof length"
      : "Length along gutter";

    roofDepthLabel.textContent = isWholeRoof
      ? "Overall roof width"
      : "Horizontal gutter-to-ridge width";

    if (roofType === "gable") {
      roofTypeHelp.textContent =
        "Enter the complete building roof length and " +
        "gable-to-gable width. The calculator assigns half " +
        "of the roof to this long gutter.";
    } else if (roofType === "hipped") {
      roofTypeHelp.textContent =
        "Enter the complete roof length and width. This assumes " +
        "a conventional equal-pitch hipped roof with the length " +
        "at least as large as the width.";
    } else {
      roofTypeHelp.textContent =
        "Enter only the rectangular roof section that drains " +
        "into this gutter.";
    }
  }

  roofTypeInput.addEventListener("change", updateRoofTypeFields);

  roofTypeButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      roofTypeInput.value = button.dataset.roofType;
      updateRoofTypeFields();
    });
  });

  updateRoofTypeFields();

  function updateOutletArrangementFields() {
    const arrangement = outletArrangementInput.value;
    const usesCount = arrangement === "evenly-spaced";
    const usesPositions = arrangement === "custom";

    outletCountField.hidden = !usesCount;
    outletPositionsField.hidden = !usesPositions;
    outletCountInput.required = usesCount;
    outletPositionsInput.required = usesPositions;
  }

  outletArrangementInput.addEventListener(
    "change",
    updateOutletArrangementFields
  );

  updateOutletArrangementFields();

  function setGutterMenuOpen(open) {
    gutterOptions.hidden = !open;
    gutterTrigger.setAttribute("aria-expanded", String(open));
  }

  gutterTrigger.addEventListener("click", function () {
    setGutterMenuOpen(gutterOptions.hidden);
  });

  gutterOptionButtons.forEach(function (option) {
    option.addEventListener("click", function () {
      const value = option.dataset.value;
      const name = option.dataset.name;
      const image = option.dataset.image;

      gutterFamilyInput.value = value;
      selectedGutterName.textContent = name;
      selectedGutterImage.src = image;

      gutterOptionButtons.forEach(function (button) {
        const selected = button === option;

        button.classList.toggle("selected", selected);
        button.setAttribute("aria-selected", String(selected));
      });

      setGutterMenuOpen(false);

      gutterFamilyInput.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );
    });
  });

  document.addEventListener("click", function (event) {
    if (!event.target.closest(".rr-gutter-picker")) {
      setGutterMenuOpen(false);
    }
  });

  let postcodeData = null;
  let rainfallData = null;

  const roundOutlets = [
    {
      label: "63mm",
      diameter: 63
    },
    {
      label: "75mm",
      diameter: 75
    },
    {
      label: "100mm",
      diameter: 100
    },
    {
      label: "125mm",
      diameter: 125
    },
    {
      label: "150mm",
      diameter: 150
    }
  ];

  const rectangularOutlets = [
    {
      label: "75 × 50mm",
      width: 75,
      depth: 50
    },
    {
      label: "75 × 75mm",
      width: 75,
      depth: 75
    },
    {
      label: "100 × 75mm",
      width: 100,
      depth: 75
    },
    {
      label: "100 × 100mm",
      width: 100,
      depth: 100
    },
    {
      label: "150 × 100mm",
      width: 150,
      depth: 100
    },
    {
      label: "150 × 150mm",
      width: 150,
      depth: 150
    }
  ];

  const gutterProfiles = [
    {
      family: "HR",
      name: "HR1 100mm Half Round",
      d1: 0,
      d2: 0,
      d3: 50,
      area: 3927,
      c: 2,
      r: 3
    },
    {
      family: "HR",
      name: "HR2 115mm Half Round",
      d1: 0,
      d2: 0,
      d3: 58,
      area: 5193,
      c: 3,
      r: 5
    },
    {
      family: "HR",
      name: "HR3 130mm Half Round",
      d1: 0,
      d2: 0,
      d3: 65,
      area: 6637,
      c: 3,
      r: 5
    },
    {
      family: "HR",
      name: "HR4 150mm Half Round",
      d1: 0,
      d2: 0,
      d3: 75,
      area: 8836,
      c: 4,
      r: 5
    },
    {
      family: "BDF",
      name: "BDF1 100mm Beaded Deep Flow",
      d1: 0,
      d2: 0,
      d3: 60,
      area: 4927,
      c: 2,
      r: 3
    },
    {
      family: "BDF",
      name: "BDF2 125mm Beaded Deep Flow",
      d1: 0,
      d2: 0,
      d3: 75,
      area: 7698,
      c: 3,
      r: 5
    },
    {
      family: "BDF",
      name: "BDF3 150mm Beaded Deep Flow",
      d1: 0,
      d2: 0,
      d3: 90,
      area: 11086,
      c: 4,
      r: 5
    },
    {
      family: "VOG",
      name: "VOG1 110mm Victorian Ogee",
      d1: 0,
      d2: 0,
      d3: 47,
      area: 3095,
      c: 2,
      r: 3
    },
    {
      family: "VOG",
      name: "VOG2 120mm Victorian Ogee",
      d1: 0,
      d2: 0,
      d3: 47,
      area: 4122,
      c: 2,
      r: 3
    },
    {
      family: "VOG",
      name: "VOG3 130mm Victorian Ogee",
      d1: 0,
      d2: 0,
      d3: 63,
      area: 5387,
      c: 3,
      r: 5
    },
    {
      family: "VOG",
      name: "VOG4 160mm Victorian Ogee",
      d1: 0,
      d2: 0,
      d3: 67,
      area: 7914,
      c: 4,
      r: 5
    },
    {
      family: "MOG",
      name: "MOG1 100 × 75mm Moulded Ogee",
      d1: 91,
      d2: 63,
      d3: 73,
      area: 0,
      c: 2,
      r: 3
    },
    {
      family: "MOG",
      name: "MOG2 125 × 100mm Moulded Ogee",
      d1: 121,
      d2: 80,
      d3: 98,
      area: 0,
      c: 3,
      r: 5
    },
    {
      family: "MOG",
      name: "MOG3 150 × 100mm Moulded Ogee",
      d1: 143,
      d2: 96,
      d3: 98,
      area: 0,
      c: 4,
      r: 5
    },
    {
      family: "MOG",
      name: "MOG4 175 × 125mm Moulded Ogee",
      d1: 170,
      d2: 108,
      d3: 123,
      area: 0,
      c: 5,
      r: 6
    },
    {
      family: "MOG",
      name: "MOG5 200 × 150mm Moulded Ogee",
      d1: 215,
      d2: 121,
      d3: 148,
      area: 0,
      c: 5,
      r: 6
    },
    {
      family: "MOG",
      name: "MOG6 300 × 200mm Moulded Ogee",
      d1: 295,
      d2: 200,
      d3: 198,
      area: 0,
      c: 5,
      r: 6
    },
    {
      family: "BNG",
      name: "BNG1 100 × 100mm Bullnose",
      d1: 102,
      d2: 101,
      d3: 100,
      area: 0,
      c: 2,
      r: 2
    },
    {
      family: "BX",
      name: "BX1 100 × 75mm Box",
      d1: 100,
      d2: 100,
      d3: 75,
      area: 0,
      c: 2,
      r: 3
    },
    {
      family: "BX",
      name: "BX2 100 × 100mm Box",
      d1: 100,
      d2: 100,
      d3: 100,
      area: 0,
      c: 2,
      r: 3
    },
    {
      family: "BX",
      name: "BX3 125 × 100mm Box",
      d1: 125,
      d2: 125,
      d3: 100,
      area: 0,
      c: 3,
      r: 5
    },
    {
      family: "BX",
      name: "BX4 150 × 100mm Box",
      d1: 150,
      d2: 150,
      d3: 100,
      area: 0,
      c: 4,
      r: 5
    },
    {
      family: "BX",
      name: "BX5 150 × 150mm Box",
      d1: 150,
      d2: 150,
      d3: 150,
      area: 0,
      c: 4,
      r: 5
    },
    {
      family: "BX",
      name: "BX6 200 × 150mm Box",
      d1: 200,
      d2: 200,
      d3: 150,
      area: 0,
      c: 5,
      r: 6
    },
    {
      family: "BX",
      name: "BX7 200 × 200mm Box",
      d1: 200,
      d2: 200,
      d3: 200,
      area: 0,
      c: 5,
      r: 6
    },
    {
      family: "BX",
      name: "BX8 300 × 200mm Box",
      d1: 300,
      d2: 300,
      d3: 200,
      area: 0,
      c: 5,
      r: 6
    },
    {
      family: "SBX",
      name: "SBX1 100 × 75mm Shaped Box Gutter",
      d1: 100,
      d2: 70,
      d3: 75,
      area: 0,
      c: 2,
      r: 2
    },
    {
      family: "SBX",
      name: "SBX2 100 × 100mm Shaped Box Gutter",
      d1: 100,
      d2: 60,
      d3: 100,
      area: 0,
      c: 2,
      r: 2
    },
    {
      family: "SBX",
      name: "SBX3 125 × 100mm Shaped Box Gutter",
      d1: 125,
      d2: 85,
      d3: 100,
      area: 0,
      c: 3,
      r: 3
    },
    {
      family: "SBX",
      name: "SBX4 150 × 100mm Shaped Box Gutter",
      d1: 150,
      d2: 110,
      d3: 100,
      area: 0,
      c: 4,
      r: 4
    },
    {
      family: "SBX",
      name: "SBX5 150 × 150mm Shaped Box Gutter",
      d1: 150,
      d2: 90,
      d3: 150,
      area: 0,
      c: 4,
      r: 4
    },
    {
      family: "SBX",
      name: "SBX6 200 × 150mm Shaped Box Gutter",
      d1: 200,
      d2: 140,
      d3: 150,
      area: 0,
      c: 5,
      r: 5
    },
    {
      family: "SBX",
      name: "SBX7 200 × 200mm Shaped Box Gutter",
      d1: 200,
      d2: 120,
      d3: 200,
      area: 0,
      c: 5,
      r: 6
    },
    {
      family: "SBX",
      name: "SBX8 300 × 200mm Shaped Box Gutter",
      d1: 300,
      d2: 220,
      d3: 200,
      area: 0,
      c: 5,
      r: 6
    },
    {
      family: "RBX",
      name: "RBX1 100 × 75mm Raked Box Gutter",
      d1: 100,
      d2: 60,
      d3: 75,
      area: 0,
      c: 2,
      r: 2
    },
    {
      family: "RBX",
      name: "RBX2 100 × 100mm Raked Box Gutter",
      d1: 100,
      d2: 60,
      d3: 100,
      area: 0,
      c: 2,
      r: 2
    },
    {
      family: "RBX",
      name: "RBX3 125 × 100mm Raked Box Gutter",
      d1: 125,
      d2: 75,
      d3: 100,
      area: 0,
      c: 3,
      r: 3
    },
    {
      family: "RBX",
      name: "RBX4 150 × 100mm Raked Box Gutter",
      d1: 150,
      d2: 75,
      d3: 100,
      area: 0,
      c: 4,
      r: 3
    },
    {
      family: "RBX",
      name: "RBX5 150 × 150mm Raked Box Gutter",
      d1: 150,      
      d2: 90,
      d3: 150,
      area: 0,
      c: 4,
      r: 4
    },
    {
      family: "RBX",
      name: "RBX6 200 × 150mm Raked Box Gutter",
      d1: 200,
      d2: 120,
      d3: 150,
      area: 0,
      c: 5,
      r: 5
    },
    {
      family: "RBX",
      name: "RBX7 200 × 200mm Raked Box Gutter",
      d1: 200,
      d2: 120,
      d3: 200,
      area: 0,
      c: 5,
      r: 6
    },
    {
      family: "RBX",
      name: "RBX8 300 × 200mm Raked Box Gutter",
      d1: 300,
      d2: 180,
      d3: 200,
      area: 0,
      c: 5,
      r: 6
    }
  ];

  function calculateFlowLengthFactor(
    lengthToOutlet,
    gutterDepth
  ) {
    const lengthRatio =
      lengthToOutlet * 1000 / gutterDepth;

    if (lengthRatio < 50) {
      return 1;
    }

    const factor =
      0.000000000000000193 * Math.pow(lengthRatio, 6) -
      0.000000000000228 * Math.pow(lengthRatio, 5) +
      0.0000000000803 * Math.pow(lengthRatio, 4) -
      0.00000000483 * Math.pow(lengthRatio, 3) -
      0.00151 * lengthRatio +
      1.08;

    return Math.max(0, Math.min(1, factor));
  }

  function calculateGutterCapacity(
    profile,
    lengthToOutlet,
    leafFactor,
    cornerFactor
  ) {
    const lengthFactor = calculateFlowLengthFactor(
      lengthToOutlet,
      profile.d3
    );

    if (profile.area > 0) {
      return (
        0.00002502 *
        leafFactor *
        cornerFactor *
        lengthFactor *
        Math.pow(profile.area, 1.25)
      );
    }

    const depthFactor =
      0.996 *
      Math.pow(profile.d3 / profile.d2, 0.262);

    const shapeRatio =
      profile.d2 / profile.d1;

    const shapeFactor =
      -0.00809 * Math.pow(shapeRatio, 6) -
      0.155 * Math.pow(shapeRatio, 5) +
      0.425 * Math.pow(shapeRatio, 4) -
      0.36 * Math.pow(shapeRatio, 3) +
      0.206 * shapeRatio +
      0.891;

    const sectionArea =
      (profile.d1 + profile.d2) *
      profile.d3 /
      2;

    return (
      0.00003132 *
      depthFactor *
      shapeFactor *
      cornerFactor *
      lengthFactor *
      Math.pow(sectionArea, 1.25)
    );
  }

  function calculateOutletCapacity(
    profile,
    outlet,
    outletShape,
    outletCoefficient
  ) {
    if (profile.area > 0) {
      if (outletShape === "round") {
        return (
          outletCoefficient *
          0.0000496 *
          Math.pow(
            outlet.diameter * outlet.diameter / 2,
            1.333
          )
        );
      }

      return (
        outletCoefficient *
        0.0000496 *
        Math.pow(
          outlet.width *
            outlet.depth *
            2 /
            Math.PI,
          1.333
        )
      );
    }

    const shapeRatio =
      profile.d2 / profile.d1;

    const waterDepth =
      profile.d3 *
      (
        -0.0719 * Math.pow(shapeRatio, 3) +
        0.295 * Math.pow(shapeRatio, 2) -
        0.402 * shapeRatio +
        0.65
      );

    if (outletShape === "round") {
      if (waterDepth > outlet.diameter / 2) {
        return (
          outletCoefficient *
          Math.pow(outlet.diameter, 2) *
          Math.sqrt(waterDepth) /
          15000
        );
      }

      return (
        outletCoefficient *
        outlet.diameter *
        Math.pow(waterDepth, 1.5) /
        7500
      );
    }

    const hydraulicRadius =
      outlet.width *
      outlet.depth /
      (
        2 *
        (outlet.width + outlet.depth)
      );

    if (waterDepth > 2 * hydraulicRadius) {
      return (
        outletCoefficient *
        outlet.width *
        outlet.depth *
        Math.sqrt(waterDepth) /
        12000
      );
    }

    return (
      outletCoefficient *
      2 *
      (outlet.width + outlet.depth) *
      Math.pow(waterDepth, 1.5) /
      24000
    );
  }

  function getOutletPositions(gutterLength) {
    const arrangement = outletArrangementInput.value;

    if (arrangement === "one-end") {
      return [gutterLength];
    }

    if (arrangement === "one-centre") {
      return [gutterLength / 2];
    }

    if (arrangement === "both-ends") {
      return [0, gutterLength];
    }

    if (arrangement === "evenly-spaced") {
      const count = Number.parseInt(
        outletCountInput.value,
        10
      );

      if (
        !Number.isInteger(count) ||
        count < 2 ||
        count > 20
      ) {
        throw new Error(
          "Please enter between 2 and 20 evenly spaced outlets."
        );
      }

      return Array.from(
        {
          length: count
        },
        function (_, index) {
          return (
            gutterLength *
            (index + 0.5) /
            count
          );
        }
      );
    }

    const positions =
      outletPositionsInput.value
        .split(",")
        .map(function (value) {
          return Number.parseFloat(value.trim());
        });

    if (
      positions.length === 0 ||
      positions.length > 20 ||
      positions.some(function (position) {
        return (
          !Number.isFinite(position) ||
          position < 0 ||
          position > gutterLength
        );
      })
    ) {
      throw new Error(
        "Enter up to 20 valid outlet positions between 0 and " +
        gutterLength.toFixed(2) +
        " metres."
      );
    }

    positions.sort(function (a, b) {
      return a - b;
    });

    if (
      positions.some(function (position, index) {
        return (
          index > 0 &&
          Math.abs(
            position - positions[index - 1]
          ) < 0.001
        );
      })
    ) {
      throw new Error(
        "Each custom outlet position must be different."
      );
    }

    return positions;
  }

  function calculateHydraulicLoading(
    requiredTotalFlow,
    gutterLength,
    outletPositions
  ) {
    const outletLoads = [];
    const hydraulicSections = [];

    outletPositions.forEach(function (position, index) {
      const leftBoundary =
        index === 0
          ? 0
          : (
              outletPositions[index - 1] +
              position
            ) / 2;

      const rightBoundary =
        index === outletPositions.length - 1
          ? gutterLength
          : (
              position +
              outletPositions[index + 1]
            ) / 2;

      const leftLength =
        position - leftBoundary;

      const rightLength =
        rightBoundary - position;

      const catchmentLength =
        leftLength + rightLength;

      outletLoads.push({
        position: position,

        requiredFlow:
          requiredTotalFlow *
          catchmentLength /
          gutterLength
      });

      [leftLength, rightLength].forEach(
        function (sectionLength) {
          if (sectionLength > 0.000001) {
            hydraulicSections.push({
              length: sectionLength,

              requiredFlow:
                requiredTotalFlow *
                sectionLength /
                gutterLength
            });
          }
        }
      );
    });

    return {
      outletPositions: outletPositions,
      outletLoads: outletLoads,
      hydraulicSections: hydraulicSections,

      requiredOutletFlow: Math.max.apply(
        null,
        outletLoads.map(function (load) {
          return load.requiredFlow;
        })
      ),

      requiredGutterFlow: Math.max.apply(
        null,
        hydraulicSections.map(function (section) {
          return section.requiredFlow;
        })
      ),

      lengthToOutlet: Math.max.apply(
        null,
        hydraulicSections.map(function (section) {
          return section.length;
        })
      )
    };
  }

  function findDrainageRecommendation(
    requiredTotalFlow,
    gutterLength,
    outletPositions
  ) {
    const loading = calculateHydraulicLoading(
      requiredTotalFlow,
      gutterLength,
      outletPositions
    );

    const leafFactor =
      leafGuardInput.value === "yes"
        ? 0.5
        : 1;

    const cornerFactor =
      gutterCornerInput.value === "yes"
        ? 0.85
        : 1;

    const outletCoefficient =
      outletObstructionInput.value === "grating"
        ? 0.5
        : 1;

    const outlets =
      outletShapeInput.value === "round"
        ? roundOutlets
        : rectangularOutlets;

    const profiles = gutterProfiles.filter(
      function (profile) {
        return (
          profile.family ===
          gutterFamilyInput.value
        );
      }
    );

    for (const profile of profiles) {
      let governingGutterCapacity = Infinity;
      let governingRequiredGutterFlow = 0;
      let smallestGutterMargin = Infinity;
      let gutterPasses = true;

      for (const section of loading.hydraulicSections) {
        const sectionCapacity =
          calculateGutterCapacity(
            profile,
            section.length,
            leafFactor,
            cornerFactor
          );

        const sectionMargin =
          sectionCapacity -
          section.requiredFlow;

        if (
          sectionMargin <
          smallestGutterMargin
        ) {
          smallestGutterMargin =
            sectionMargin;

          governingGutterCapacity =
            sectionCapacity;

          governingRequiredGutterFlow =
            section.requiredFlow;
        }

        if (
          sectionCapacity <
          section.requiredFlow
        ) {
          gutterPasses = false;
          break;
        }
      }

      if (!gutterPasses) {
        continue;
      }

      const permittedCount =
        outletShapeInput.value === "round"
          ? profile.c
          : profile.r;

      const permittedOutlets =
        outlets.slice(0, permittedCount);

      for (const outlet of permittedOutlets) {
        const outletCapacity =
          calculateOutletCapacity(
            profile,
            outlet,
            outletShapeInput.value,
            outletCoefficient
          );

        if (
          outletCapacity >=
          loading.requiredOutletFlow
        ) {
          return Object.assign({}, loading, {
            profile: profile,
            outlet: outlet,
            outletCount: outletPositions.length,

            gutterCapacity:
              governingGutterCapacity,

            requiredGutterFlow:
              governingRequiredGutterFlow,

            outletCapacity:
              outletCapacity,

            leafFactor:
              leafFactor,

            cornerFactor:
              cornerFactor,

            outletCoefficient:
              outletCoefficient
          });
        }
      }
    }

    return Object.assign({}, loading, {
      profile: null,
      outlet: null,
      outletCount: outletPositions.length
    });
  }

  const englishRainfallRates = {
    London: 0.022,
    "South East": 0.022,
    "East of England": 0.022,
    "South West": 0.020,
    "East Midlands": 0.018,
    "West Midlands": 0.018,
    "North West": 0.015,
    "North East": 0.015,
    "Yorkshire and The Humber": 0.015
  };

  function getRainfallRate(postcodeResult) {
    if (!postcodeResult) {
      return null;
    }

    const country = postcodeResult.country;
    const region = postcodeResult.region;

    if (country === "Scotland") {
      return {
        rate: 0.010,
        location: "Scotland",
        method: "Simplified regional design rate"
      };
    }

    if (country === "Northern Ireland") {
      return {
        rate: 0.014,
        location: "Northern Ireland",
        method: "Simplified regional design rate"
      };
    }

    if (country === "Wales") {
      return {
        rate: 0.017,
        location: "Wales",
        method: "Simplified regional design rate"
      };
    }

    if (
      country === "England" &&
      englishRainfallRates[region]
    ) {
      return {
        rate: englishRainfallRates[region],
        location: region,
        method: "Simplified regional design rate"
      };
    }

    return {
      rate: 0.022,

      location:
        region ||
        country ||
        "United Kingdom",

      method:
        "Conservative UK fallback"
    };
  }

  function showMessage(element, message, type) {
    element.textContent = message;

    element.className =
      "rr-message rr-message--" + type;

    element.hidden = false;
  }

  function hideMessage(element) {
    element.hidden = true;
    element.textContent = "";
    element.className = "rr-message";
  }

  function normalisePostcode(postcode) {
    return postcode
      .trim()
      .replace(/\s+/g, " ")
      .toUpperCase();
  }

  async function lookupPostcode() {
    const postcode = normalisePostcode(
      postcodeInput.value
    );

    hideMessage(postcodeMessage);
    locationResult.hidden = true;
    postcodeData = null;
    rainfallData = null;

    if (!postcode) {
      showMessage(
        postcodeMessage,
        "Please enter a UK postcode.",
        "error"
      );

      postcodeInput.focus();
      return;
    }

    postcodeButton.disabled = true;
    postcodeButton.textContent = "Checking...";

    try {
      const endpoint =
        "https://api.postcodes.io/postcodes/" +
        encodeURIComponent(postcode);

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          Accept: "application/json"
        }
      });

      const data = await response.json();

      if (!response.ok || !data.result) {
        throw new Error(
          data.error ||
          "Postcode not found"
        );
      }

      postcodeData = data.result;
      rainfallData = getRainfallRate(postcodeData);
      postcodeInput.value = postcodeData.postcode;

      document.getElementById(
        "rr-result-postcode"
      ).textContent =
        postcodeData.postcode;

      document.getElementById(
        "rr-result-region"
      ).textContent =
        postcodeData.region ||
        postcodeData.admin_county ||
        postcodeData.country ||
        "Not available";

      document.getElementById(
        "rr-result-latitude"
      ).textContent =
        Number(
          postcodeData.latitude
        ).toFixed(6);

      document.getElementById(
        "rr-result-longitude"
      ).textContent =
        Number(
          postcodeData.longitude
        ).toFixed(6);

      document.getElementById(
        "rr-result-rainfall"
      ).textContent =
        rainfallData.rate.toFixed(3) +
        " l/s/m²";

      locationResult.hidden = false;

      showMessage(
        postcodeMessage,
        "Postcode found successfully.",
        "success"
      );
    } catch (error) {
      showMessage(
        postcodeMessage,
        "We could not find that postcode. " +
        "Please check it and try again.",
        "error"
      );
    } finally {
      postcodeButton.disabled = false;
      postcodeButton.textContent =
        "Check postcode";
    }
  }

  /*
   * These Manning roughness values are provisional.
   * Replace them with validated Guttercrest test data
   * before describing the capture result as certified.
   */
  const roofSurfaceRoughness = {
    "smooth-metal": 0.011,
    "profiled-metal": 0.015,
    slate: 0.016,
    tile: 0.018
  };

  function getProfileOpeningWidth(profile) {
    if (profile.d1 > 0) {
      return profile.d1;
    }

    const sizeMatch = profile.name.match(
      /^\S+\s+(\d+(?:\.\d+)?)/
    );

    return sizeMatch
      ? Number.parseFloat(sizeMatch[1])
      : null;
  }

  function calculateCaptureAssessment(options) {
    const slopeLength =
      options.horizontalRun /
      Math.max(
        Math.cos(options.pitchRadians),
        0.000001
      );

    const baseResult = {
      status: "not-calculated",
      slopeLength: slopeLength,
      horizontalTravelMm: null,
      availableCaptureMm: null,
      estimatedVelocityMs: null,

      message:
        "The capture assessment could not be calculated."
    };

    if (options.flowConcentration !== "normal") {
      return Object.assign(baseResult, {
        status: "specialist",

        message:
          "Concentrated valley or upper-roof flow needs a separate " +
          "specialist capture assessment. It has not been given a pass."
      });
    }

    const roughness =
      roofSurfaceRoughness[
        options.roofSurface
      ];

    if (!roughness) {
      return Object.assign(baseResult, {
        status: "unknown",

        message:
          "Select a recognised roof surface before estimating " +
          "overshoot risk."
      });
    }

    const openingWidthMm =
      getProfileOpeningWidth(options.profile);

    const availableCaptureMm =
      openingWidthMm -
      options.gutterOverlapMm;

    if (availableCaptureMm <= 0) {
      return Object.assign(baseResult, {
        status: "invalid",
        availableCaptureMm: availableCaptureMm,

        message:
          "The entered roof-edge overlap is greater than the " +
          "selected gutter opening. Check the installation measurements."
      });
    }

    const gradient =
      Math.tan(options.pitchRadians);

    let velocity = 0;

    if (gradient > 0.000001) {
      /*
       * rainfallRate is in l/s/m².
       *
       * Multiplying by 0.001 converts it into m/s.
       *
       * horizontalRun is used because vertical rainfall is
       * collected over the horizontal plan width rather than
       * the physical sloping roof length.
       */
      const flowPerMetre =
        options.rainfallRate *
        0.001 *
        options.horizontalRun;

      const filmDepth =
        Math.pow(
          flowPerMetre *
          roughness /
          Math.sqrt(gradient),
          3 / 5
        );

      velocity =
        filmDepth > 0
          ? flowPerMetre / filmDepth
          : 0;
    }

    const horizontalVelocity =
      velocity *
      Math.cos(options.pitchRadians);

    const downwardVelocity =
      velocity *
      Math.sin(options.pitchRadians);

    const verticalDropM =
      options.verticalDropMm / 1000;

    const gravity = 9.81;

    const flightTime =
      (
        -downwardVelocity +
        Math.sqrt(
          downwardVelocity *
          downwardVelocity +
          2 *
          gravity *
          verticalDropM
        )
      ) /
      gravity;

    const horizontalTravelMm =
      horizontalVelocity *
      flightTime *
      1000;

    const captured =
      horizontalTravelMm <=
      availableCaptureMm;

    let detailWarning = "";

    if (options.eavesDetail === "unknown") {
      detailWarning =
        " The eaves detail is unknown, reducing confidence.";
    }

    return Object.assign(baseResult, {
      status: captured
        ? "likely-captured"
        : "overshoot-risk",

      horizontalTravelMm:
        horizontalTravelMm,

      availableCaptureMm:
        availableCaptureMm,

      estimatedVelocityMs:
        velocity,

      message: captured
        ? (
            "The estimated trajectory lands within the gutter opening. " +
            "This is an indicative result pending physical validation." +
            detailWarning
          )
        : (
            "The estimated trajectory reaches beyond the available " +
            "gutter opening. Reposition the gutter or review the " +
            "eaves detail." +
            detailWarning
          )
    });
  }

  function renderCaptureAssessment(capture) {
    document.getElementById(
      "rr-capture-slope-length"
    ).textContent =
      capture.slopeLength.toFixed(2) +
      " m";

    document.getElementById(
      "rr-capture-travel"
    ).textContent =
      capture.horizontalTravelMm === null
        ? "—"
        : (
            capture.horizontalTravelMm.toFixed(0) +
            " mm"
          );

    document.getElementById(
      "rr-capture-zone"
    ).textContent =
      capture.availableCaptureMm === null
        ? "—"
        : (
            Math.max(
              0,
              capture.availableCaptureMm
            ).toFixed(0) +
            " mm"
          );

    const statusLabels = {
      "likely-captured":
        "Likely captured — indicative",

      "overshoot-risk":
        "Overshoot risk",

      specialist:
        "Specialist assessment required",

      unknown:
        "Insufficient surface data",

      invalid:
        "Check measurements",

      "not-calculated":
        "Not calculated"
    };

    document.getElementById(
      "rr-capture-status"
    ).textContent =
      statusLabels[capture.status] ||
      "Not calculated";

    document.getElementById(
      "rr-capture-explanation"
    ).textContent =
      capture.message;
  }

  function calculateRoof() {
    hideMessage(formMessage);

    if (!postcodeData || !rainfallData) {
      showMessage(
        formMessage,
        "Please enter and check the property postcode first.",
        "error"
      );

      postcodeInput.focus();
      return;
    }

    const roofLength =
      Number.parseFloat(
        roofLengthInput.value
      );

    const roofDepth =
      Number.parseFloat(
        roofDepthInput.value
      );

    const roofPitch =
      Number.parseFloat(
        roofPitchInput.value
      );

    const roofType =
      roofTypeInput.value;

    const hippedSide =
      hippedSideInput.value;

    const verticalDropMm =
      Number.parseFloat(
        verticalDropInput.value
      );

    const gutterOverlapMm =
      Number.parseFloat(
        gutterOverlapInput.value
      );

    if (
      !Number.isFinite(roofLength) ||
      roofLength <= 0
    ) {
      showMessage(
        formMessage,
        "Please enter a valid gutter length.",
        "error"
      );

      roofLengthInput.focus();
      return;
    }

    if (
      !Number.isFinite(roofDepth) ||
      roofDepth <= 0
    ) {
      showMessage(
        formMessage,
        "Please enter a valid horizontal gutter-to-ridge depth.",
        "error"
      );

      roofDepthInput.focus();
      return;
    }

    if (
      !Number.isFinite(roofPitch) ||
      roofPitch < 0 ||
      roofPitch > 70
    ) {
      showMessage(
        formMessage,
        "Please enter a roof pitch between 0 and 70 degrees.",
        "error"
      );

      roofPitchInput.focus();
      return;
    }

    if (
      !Number.isFinite(verticalDropMm) ||
      verticalDropMm < 0
    ) {
      showMessage(
        formMessage,
        "Please enter a valid vertical drop to the gutter opening.",
        "error"
      );

      verticalDropInput.focus();
      return;
    }

    if (
      !Number.isFinite(gutterOverlapMm) ||
      gutterOverlapMm < 0
    ) {
      showMessage(
        formMessage,
        "Please enter a valid roof-edge overlap into the gutter.",
        "error"
      );

      gutterOverlapInput.focus();
      return;
    }

    const pitchRadians =
      roofPitch *
      Math.PI /
      180;

    let planArea;
    let gutterRunLength;
    let catchmentDescription;

    if (roofType === "gable") {
      /*
       * A gable roof has two slopes.
       *
       * This calculator sizes one gutter, so only one-half of
       * the complete building plan area is assigned to it.
       */
      planArea =
        roofLength *
        roofDepth /
        2;

      gutterRunLength =
        roofLength;

      catchmentDescription =
        "one rectangular side of the gable roof";
    } else if (roofType === "hipped") {
      if (roofLength < roofDepth) {
        showMessage(
          formMessage,
          "For a hipped roof, enter the longer overall dimension " +
          "as the roof length and the shorter dimension as the roof width.",
          "error"
        );

        roofLengthInput.focus();
        return;
      }

      if (hippedSide === "end") {
        /*
         * One triangular short hip end.
         */
        planArea =
          roofDepth *
          roofDepth /
          4;

        gutterRunLength =
          roofDepth;

        catchmentDescription =
          "the triangular short hip end";
      } else {
        /*
         * One trapezoidal long side.
         */
        planArea =
          (
            2 *
            roofLength -
            roofDepth
          ) *
          roofDepth /
          4;

        gutterRunLength =
          roofLength;

        catchmentDescription =
          "the trapezoidal long side of the hipped roof";
      }
    } else {
      planArea =
        roofLength *
        roofDepth;

      gutterRunLength =
        roofLength;

      catchmentDescription =
        "the entered roof section";
    }

    const cosine =
      Math.cos(pitchRadians);

    const slopeArea =
      cosine > 0
        ? planArea / cosine
        : planArea;

    const pitchFactor =
      1 +
      Math.tan(pitchRadians) /
      2;

    const effectiveArea =
      planArea *
      pitchFactor;

    const rainfallRate =
      rainfallData.rate;

    /*
     * Runoff coefficient is fixed at 1 for an ordinary
     * impermeable roof.
     */
    const runoffCoefficient = 1;

    const rainwaterFlow =
      effectiveArea *
      rainfallRate *
      runoffCoefficient;

    let outletPositions;

    try {
      outletPositions =
        getOutletPositions(
          gutterRunLength
        );
    } catch (error) {
      showMessage(
        formMessage,
        error.message,
        "error"
      );

      if (
        outletArrangementInput.value ===
        "custom"
      ) {
        outletPositionsInput.focus();
      } else {
        outletCountInput.focus();
      }

      return;
    }

    const recommendation =
      findDrainageRecommendation(
        rainwaterFlow,
        gutterRunLength,
        outletPositions
      );

    /*
     * For a complete gable or hipped roof, the horizontal
     * distance travelled down one slope is normally half of
     * the overall roof width.
     */
    const horizontalRunForCapture =
      roofType === "single"
        ? roofDepth
        : roofDepth / 2;

    const captureAssessment =
      recommendation.profile
        ? calculateCaptureAssessment({
            horizontalRun:
              horizontalRunForCapture,

            pitchRadians:
              pitchRadians,

            rainfallRate:
              rainfallRate,

            roofSurface:
              roofSurfaceInput.value,

            eavesDetail:
              eavesDetailInput.value,

            flowConcentration:
              flowConcentrationInput.value,

            verticalDropMm:
              verticalDropMm,

            gutterOverlapMm:
              gutterOverlapMm,

            profile:
              recommendation.profile
          })
        : {
            status:
              "not-calculated",

            slopeLength:
              horizontalRunForCapture /
              Math.max(
                cosine,
                0.000001
              ),

            horizontalTravelMm:
              null,

            availableCaptureMm:
              null,

            message:
              "Capture cannot be assessed until a suitable gutter " +
              "profile has been selected by the capacity calculation."
          };

    document.getElementById(
      "rr-plan-area"
    ).textContent =
      planArea.toFixed(2) +
      " m²";

    document.getElementById(
      "rr-slope-area"
    ).textContent =
      slopeArea.toFixed(2) +
      " m²";

    document.getElementById(
      "rr-effective-area"
    ).textContent =
      effectiveArea.toFixed(2) +
      " m²";

    document.getElementById(
      "rr-main-area"
    ).textContent =
      effectiveArea.toFixed(2) +
      " m²";

    document.getElementById(
      "rr-pitch-factor"
    ).textContent =
      pitchFactor.toFixed(3);

    document.getElementById(
      "rr-rainfall-rate"
    ).textContent =
      rainfallRate.toFixed(3) +
      " l/s/m²";

    document.getElementById(
      "rr-rainfall-location"
    ).textContent =
      rainfallData.location +
      " — " +
      rainfallData.method;

    document.getElementById(
      "rr-rainwater-flow"
    ).textContent =
      rainwaterFlow.toFixed(2) +
      " l/s";

    document.getElementById(
      "rr-flow-explanation"
    ).textContent =
      "Using " +
      catchmentDescription +
      ": " +
      effectiveArea.toFixed(2) +
      "m² effective drainage area × " +
      rainfallRate.toFixed(3) +
      " l/s/m² × runoff coefficient 1 = " +
      rainwaterFlow.toFixed(2) +
      " litres per second.";

    if (
      recommendation.profile &&
      recommendation.outlet
    ) {
      document.getElementById(
        "rr-selected-gutter"
      ).textContent =
        recommendation.profile.name;

      document.getElementById(
        "rr-selected-gutter-details"
      ).textContent =
        "Required " +
        recommendation.requiredGutterFlow.toFixed(2) +
        " l/s · achieved " +
        recommendation.gutterCapacity.toFixed(2) +
        " l/s · hydraulic length " +
        recommendation.lengthToOutlet.toFixed(2) +
        " m";

      document.getElementById(
        "rr-selected-outlets"
      ).textContent =
        recommendation.outletCount +
        " × " +
        recommendation.outlet.label +
        " " +
        (
          outletShapeInput.value === "round"
            ? "round outlet"
            : "rectangular outlet"
        );

      document.getElementById(
        "rr-flow-per-outlet"
      ).textContent =
        "Busiest outlet: required " +
        recommendation.requiredOutletFlow.toFixed(2) +
        " l/s · achieved " +
        recommendation.outletCapacity.toFixed(2) +
        " l/s";
    } else {
      document.getElementById(
        "rr-selected-gutter"
      ).textContent =
        "Design failed";

      document.getElementById(
        "rr-selected-gutter-details"
      ).textContent =
        "No suitable profile in this gutter family. " +
        "Add outlets or choose another family.";

      document.getElementById(
        "rr-selected-outlets"
      ).textContent =
        "No suitable outlet";

      document.getElementById(
        "rr-flow-per-outlet"
      ).textContent =
        "Required capacity at the busiest outlet: " +
        recommendation.requiredOutletFlow.toFixed(2) +
        " l/s";
    }

    renderCaptureAssessment(
      captureAssessment
    );

    results.hidden = false;

    results.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });

    console.log(
      "Rainwater calculator result",
      {
        postcode:
          postcodeData
            ? postcodeData.postcode
            : null,

        latitude:
          postcodeData
            ? postcodeData.latitude
            : null,

        longitude:
          postcodeData
            ? postcodeData.longitude
            : null,

        roofLength:
          roofLength,

        roofDepth:
          roofDepth,

        roofType:
          roofType,

        hippedSide:
          roofType === "hipped"
            ? hippedSide
            : null,

        gutterRunLength:
          gutterRunLength,

        catchmentDescription:
          catchmentDescription,

        roofPitch:
          roofPitch,

        planArea:
          planArea,

        slopeArea:
          slopeArea,

        pitchFactor:
          pitchFactor,

        effectiveArea:
          effectiveArea,

        runoffCoefficient:
          runoffCoefficient,

        rainfallRate:
          rainfallRate,

        rainfallLocation:
          rainfallData.location,

        rainwaterFlow:
          rainwaterFlow,

        gutter:
          recommendation.profile,

        outletShape:
          outletShapeInput.value,

        outlet:
          recommendation.outlet,

        outletArrangement:
          outletArrangementInput.value,

        outletCount:
          outletPositions.length,

        outletPositions:
          outletPositions,

        requiredGutterFlow:
          recommendation.requiredGutterFlow,

        requiredFlowPerOutlet:
          recommendation.requiredOutletFlow,

        gutterCapacity:
          recommendation.gutterCapacity ||
          null,

        outletCapacity:
          recommendation.outletCapacity ||
          null,

        lengthToOutlet:
          recommendation.lengthToOutlet,

        captureAssessment:
          captureAssessment
      }
    );
  }

  postcodeButton.addEventListener(
    "click",
    lookupPostcode
  );

  postcodeInput.addEventListener(
    "keydown",
    function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        lookupPostcode();
      }
    }
  );

  document
    .querySelectorAll(".rr-pitch-button")
    .forEach(function (button) {
      button.addEventListener(
        "click",
        function () {
          roofPitchInput.value =
            button.dataset.pitch;
        }
      );
    });

  form.addEventListener(
    "submit",
    function (event) {
      event.preventDefault();
      calculateRoof();
    }
  );
})();